import IconUploadComponentView from './IconUploadComponent.view';
export * from './IconUploadComponent.view';

export const IconUploadComponent = (props) => IconUploadComponentView(props);

export default IconUploadComponent;

